import { Store } from '@betgames/bg-state-manager';
import { StoresEntity } from '@bg-shared/business/StoreFeature';
import { GameId } from '@bg-shared/enums/GameId';
import { IGameOptions } from './interfaces';

export const gamesOptionsEntity = new StoresEntity(
    class GameOptionsStore extends Store<IGameOptions> {
        constructor(gameId: GameId) {
            super({
                key: `GameOptions/${gameId}`,
                default: null,
            });
        }

        public updateValues(options: Array<{ id: number; value: number }>): void {
            this.update((draft) => {
                options.forEach((option) => {
                    draft.options[option.id].value = option.value;
                });
            });
        }
    },
);
